import styled from 'styled-components'

export const VideosListContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  overflow: auto;
  flex-grow: 1;
  list-style-type: none;
`
